import { useReducer, useEffect } from 'react';
import { produce } from 'immer';
import Raven from 'raven-js';
import AccessGroupsAPI from '../api/accessGroups';
import RequestStatusTypes from 'settings-ui-lib/constants/RequestStatusTypes';
import { AccessGroupsActionTypes } from '../constants/ActionTypes';
const initialState = {
  accessGroups: [],
  accessGroupsRequestStatus: RequestStatusTypes.UNINITIALIZED
};
const accessGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AccessGroupsActionTypes.PENDING:
      return produce(state, draft => {
        draft.accessGroupsRequestStatus = RequestStatusTypes.PENDING;
      });
    case AccessGroupsActionTypes.SUCCEEDED:
      return produce(state, draft => {
        draft.accessGroupsRequestStatus = RequestStatusTypes.SUCCEEDED;
        draft.accessGroups = action.accessGroups;
      });
    case AccessGroupsActionTypes.FAILED:
      return produce(state, draft => {
        draft.accessGroupsRequestStatus = RequestStatusTypes.FAILED;
      });
    default:
      return state;
  }
};
const accessGroupsRequested = () => ({
  type: AccessGroupsActionTypes.PENDING
});
const accessGroupsReceived = accessGroups => ({
  type: AccessGroupsActionTypes.SUCCEEDED,
  accessGroups
});
const accessGroupsFailed = () => ({
  type: AccessGroupsActionTypes.FAILED
});
export default (({
  accessGroupIds,
  shouldFetchData = true
} = {}) => {
  const [accessGroupsState, dispatch] = useReducer(accessGroupsReducer, initialState);
  const onSuccess = data => {
    dispatch(accessGroupsReceived(data));
  };
  const onError = error => {
    dispatch(accessGroupsFailed());
    Raven.captureException(error, {
      extra: {
        message: 'Access Groups fetch failed in ui-memberships-settings-lib'
      }
    });
  };
  useEffect(() => {
    let mounted = true;
    if (mounted && shouldFetchData) {
      dispatch(accessGroupsRequested());
      AccessGroupsAPI.getAccessGroups(accessGroupIds).then(onSuccess).catch(onError);
    }
    return () => {
      mounted = false;
    };
  }, [accessGroupIds, shouldFetchData]);
  return {
    accessGroups: accessGroupsState.accessGroups,
    accessGroupsRequestStatus: accessGroupsState.accessGroupsRequestStatus
  };
});